import { mapGetters } from 'vuex'

export const getGetters = () => mapGetters({
  projests: 'projests',
  delete_model: 'delete_model',
  updated_model: 'updated_model',
  statesMaterial: 'statesMaterial',
  inspectors: 'inspectors',
  contractors: 'contractors',
  eventFireGlobalTotal: 'eventFireGlobalTotal',
  loadingEventFireWithGlobalTotal: 'loadingEventFireWithGlobalTotal',
  loadingEventStatusUpdate: 'loadingEventStatusUpdate',
  eventStatus: 'eventStatus',
  bankAccountTypes: 'bankAccountTypes',
  bankAccountTypeAccounts: 'bankAccountTypeAccounts',
  bankTypes: 'bankTypes',
  statesJobsStates: 'statesJobsStates',
  salesProjectModels: 'salesProjectModels',
  salesDocumentStatus: 'salesDocumentStatus',
  salesStatesPrecontract: 'salesStatesPrecontract',
  salesSatesCard: 'salesSatesCard',
  salesBankApplicationStatus: 'salesBankApplicationStatus',
  batchTypes: 'batchTypes',
  salesProcessors: 'salesProcessors',
  paymentTypeModules: 'paymentTypeModules',
  accountingAccounts: 'accountingAccounts',
  appointmentStatus: 'appointmentStatus',
  typeUsers: 'typeUsers',
  statusCostumerPayments: 'statusCostumerPayments',
  prioritiesEntry: 'prioritiesEntry',
  departamentsEntry: 'departamentsEntry',
  statusEntry: 'statusEntry',
  users: 'users',
  writingStatus: 'writingStatus',
  systemModules: 'modules',
  systemRoles: 'listRoles',
  moduleIndicator: 'moduleIndicator',
  userSettings: 'userSettings',
  bankAccounts: 'bankAccounts',
  typeAssignments: 'typeAssignments',
  completeBankApplicationStatus: 'completeBankApplicationStatus',
  completeSalesStatesPrecontract: 'completeSalesStatesPrecontract',
  systemPermissions: 'listPermissions',
  organizationalRoleType: 'organizationalRoleType',
  salesBankApplicationStatusByNameId: 'salesBankApplicationStatusByNameId',
  salesDocumentStatusByNameId: 'salesDocumentStatusByNameId',
  lastCustomerActions: 'lastCustomerActions',
  addendumStatus: 'addendumStatus',
})
